import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexGrow: 1,
  },
});
